// Copyright © 2024 650 Industries.

'use client';

import { View } from 'react-native';

import type { GlassViewProps } from './GlassView.types';

export default function GlassView(props: GlassViewProps) {
  return <View {...props} />;
}
